import { render, staticRenderFns } from "./TwoFactorsAuth.vue?vue&type=template&id=c4d35174&scoped=true"
import script from "./TwoFactorsAuth.vue?vue&type=script&lang=js"
export * from "./TwoFactorsAuth.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorsAuth.vue?vue&type=style&index=0&id=c4d35174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d35174",
  null
  
)

export default component.exports